import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

import breakpoints from '../utils/breakpoints';
import { setAriaLabelledBy } from '../utils/dom';
import { getGenericSliderConfig } from '../utils/slider';

class KeyDates extends Component {
  setupDefaults() {
    this.dom = {
      $slides: this.el._$$('.swiper-slide'),
      $swiperContainer: this.el._$('.swiper-container'),
      $cards: this.el._$$('.key-dates__card')
    };

    this.initSlider();
    this.labelCards();
  }

  initSlider() {
    const { $swiperContainer } = this.dom;
    const element = this.el;

    new Swiper($swiperContainer, {
      ...getGenericSliderConfig(element, null, 'Key Dates'),
      breakpoints: {
        [breakpoints.tablet]: {
          slidesPerView: 2,
          spaceBetween: 40,
          noSwiping: true,
          watchOverflow: true
        },
        [breakpoints.lg]: {
          slidesPerView: 3,
          spaceBetween: 30,
          noSwiping: true,
          watchOverflow: true
        }
      },
      on: {
        init() {
          $swiperContainer.classList.remove('loading');
          $swiperContainer.classList.add('loaded');
        }
      }
    });
  }
  labelCards() {
    this.dom.$cards.forEach(($card) => {
      const $title = $card._$('.key-dates__title');
      setAriaLabelledBy($card, $title);
    });
  }
}

export default KeyDates;
